
//------------------------------------------------------------------------------
// <auto-generated>
//     This code was generated from a template (Enum.tst).
//
//     Manual changes to this file may cause unexpected behavior in your application.
//     Manual changes to this file will be overwritten if the code is regenerated.
// </auto-generated>
//------------------------------------------------------------------------------

export enum LogEntryType {
	Event = 0,
	Internal = 1,
	Mail = 2,
	Sms = 3
}
export namespace LogEntryType {
	export function getKeys(): Map<LogEntryType, string> {
		return new Map([[0, 'Event'], [1, 'Internal'], [2, 'Mail'], [3, 'Sms']]);
	}
}
